<template>
  <li class="job-item" v-show="round.active">
    <div @click="_openModal">
      <div class="row no-gutters">
        <div class="col-11">
          <div class="job-item-name">
            <strong>{{ getName() }}</strong>
          </div>
        </div>
        <div class="col-1" v-if="schedule_index >= 0">
          <div class="schedule_number_tag">
            <strong>W{{ schedules[schedule_index].duration }}</strong>
          </div>
        </div>
      </div>
      <div class="job-item-area">
        {{ getArea() }}
      </div>
      <div class="job-item-employees">
        <span
          v-for="(employee, index) in round.personnels"
          v-bind:key="id + 'emp' + index"
        >
          <span v-if="index != 0">, </span><span>{{ employee.name }}</span>
        </span>
      </div>
      <div class="job-item-vehicle">{{ getVehicleName() }}</div>
    </div>

    <JobCustomerSelection
      v-if="editable && showModal"
      v-bind:key="id + 'cust-select'"
      @close="_close"
      @save="_save"
      @delete="_delete"
      @copy="_copy"
      @move="_move"
      @add-change="_add_change"
      :schedule_index="schedule_index"
      :schedule_round="round"
      :available_jobs="available_jobs"
      :week_index="week_index"
      :day_index="day_index"
      :editable="editable"
    />
    <JobSummary
      v-if="!editable && showModal"
      v-bind:key="id + 'cust-select'"
      @close="_close"
      @save="_close"
      @delete="_delete"
      @copy="_copy"
      :schedule_index="schedule_index"
      :schedule_round="round"
      :available_jobs="available_jobs"
      :week_index="week_index"
      :day_index="day_index"
      :editable="editable"
    />
  </li>
</template>

<script>
import JobCustomerSelection from "@/components/job/JobCustomerSelection.vue";
import JobSummary from "@/components/job/view/JobSummary.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "JobRoundDisplay",
  props: {
    round: {
      type: Object,
      required: true,
    },
    schedule_index: {
      type: Number,
      default: -1,
    },
    week_index: {
      type: Number,
      default: -1,
    },
    day_index: {
      type: Number,
      default: -1,
    },
    editable: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    showModal: false,
    id: -1,
  }),
  computed: {
    ...mapState("schedule", ["schedules", "available_jobs"]),
  },
  mounted: function() {
    this.id = this._uid;
  },
  watch: {},
  methods: {
    ...mapActions("status", [
      "enable_job_dragging",
      "disable_job_dragging",
      "copy_round",
      "move_round",
      "add_round_change",
    ]),
    getName() {
      return this.round.round.name;
    },
    getArea() {
      return this.round.round.area;
    },
    getVehicleName() {
      if (!this.round.vehicle) {
        return "";
      } else {
        return this.round.vehicle.name;
      }
    },
    _copy() {
      this._closeModal();
      this.copy_round(this.round);
    },
    _move() {
      this._closeModal();
      this.round.active = false;
      this.move_round(this.round);
    },
    _add_change() {
      this._closeModal();
      this.add_round_change(this.round);
    },
    _delete() {
      this.round.active = false;
      this._closeModal();
    },
    _save() {
      this.$emit("saved");
      this._closeModal();
    },
    _close() {
      this._closeModal();
    },
    _openModal() {
      this.disable_job_dragging();
      this.showModal = true;
      this.round.fixed = true;
    },
    _closeModal() {
      this.enable_job_dragging();
      this.showModal = false;
      this.round.fixed = false;
    },
  },
  components: {
    JobCustomerSelection,
    JobSummary,
  },
};
</script>
